import { RenderTargetFormat } from "../../RenderEngine/RenderEnum/RenderTargetFormat";
import { Shader3D } from "../../RenderEngine/RenderShader/Shader3D";
import { Vector4 } from "../../maths/Vector4";
import { DepthTextureMode, RenderTexture } from "../../resource/RenderTexture";
export class DepthPass {
    static __init__() {
        DepthPass.DEPTHPASS = Shader3D.getDefineByName("DEPTHPASS");
        DepthPass.DEFINE_SHADOW_BIAS = Shader3D.propertyNameToID("u_ShadowBias");
        DepthPass.DEPTHTEXTURE = Shader3D.propertyNameToID("u_CameraDepthTexture");
        DepthPass.DEPTHNORMALSTEXTURE = Shader3D.propertyNameToID("u_CameraDepthNormalsTexture");
        DepthPass.DEPTHZBUFFERPARAMS = Shader3D.propertyNameToID("u_ZBufferParams");
    }
    constructor() {
        this._zBufferParams = new Vector4();
    }
    getTarget(camera, depthType, depthTextureFormat) {
        this._viewPort = camera.viewport;
        switch (depthType) {
            case DepthTextureMode.Depth:
                {
                    if (camera.canblitDepth && camera._internalRenderTexture.depthStencilTexture) {
                        camera.depthTexture = this._depthTexture = camera._cacheDepthTexture;
                        camera.depthTextureMode &= ~DepthTextureMode.Depth;
                    }
                    else {
                        camera.depthTexture = this._depthTexture = RenderTexture.createFromPool(this._viewPort.width, this._viewPort.height, depthTextureFormat, RenderTargetFormat.None, false, 1);
                    }
                }
                break;
            case DepthTextureMode.DepthNormals:
                camera.depthNormalTexture = this._depthNormalsTexture = RenderTexture.createFromPool(this._viewPort.width, this._viewPort.height, RenderTargetFormat.R8G8B8A8, depthTextureFormat, false, 1);
                break;
            case DepthTextureMode.MotionVectors:
                break;
            default:
                throw ("there is UnDefined type of DepthTextureMode");
        }
    }
    _setupDepthModeShaderValue(depthType, camera) {
        switch (depthType) {
            case DepthTextureMode.Depth:
                var far = camera.farPlane;
                var near = camera.nearPlane;
                this._zBufferParams.setValue(1.0 - far / near, far / near, (near - far) / (near * far), 1 / near);
                camera._shaderValues.setVector(DepthPass.DEFINE_SHADOW_BIAS, DepthPass.SHADOW_BIAS);
                camera._shaderValues.setTexture(DepthPass.DEPTHTEXTURE, this._depthTexture);
                camera._shaderValues.setVector(DepthPass.DEPTHZBUFFERPARAMS, this._zBufferParams);
                break;
            case DepthTextureMode.DepthNormals:
                camera._shaderValues.setTexture(DepthPass.DEPTHNORMALSTEXTURE, this._depthNormalsTexture);
                break;
            default:
                throw ("there is UnDefined type of DepthTextureMode");
        }
    }
    cleanUp(camera) {
        if (this._depthTexture) {
            let cameraDephtTex = camera._shaderValues.getTexture(DepthPass.DEPTHTEXTURE);
            if (cameraDephtTex == this._depthTexture) {
                camera._shaderValues.setTexture(DepthPass.DEPTHTEXTURE, null);
                camera.depthTexture = null;
            }
            RenderTexture.recoverToPool(this._depthTexture);
            this._depthTexture = null;
        }
        if (this._depthNormalsTexture) {
            let cameraDepthNormalTex = camera._shaderValues.getTexture(DepthPass.DEPTHNORMALSTEXTURE);
            if (cameraDepthNormalTex == this._depthNormalsTexture) {
                camera._shaderValues.setTexture(DepthPass.DEPTHNORMALSTEXTURE, null);
                camera.depthNormalTexture = null;
            }
            RenderTexture.recoverToPool(this._depthNormalsTexture);
            this._depthNormalsTexture = null;
        }
    }
}
DepthPass.SHADOW_BIAS = new Vector4();
